import * as React from "react";
import styles from './style.css';

// Heart-shaped loader in the theme accent (purple in base, gold in memorial):
// a faint heart outline with an accent stroke tracing around it, and a small
// heartbeat pulse.
const HEART = "M24 41 C 10 31 3 23 3 14.5 C 3 8.5 7.8 4 13.5 4 C 17.8 4 21.6 6.5 24 10.3 C 26.4 6.5 30.2 4 34.5 4 C 40.2 4 45 8.5 45 14.5 C 45 23 38 31 24 41 Z";

export default function LayoutComponentsHeartLoader() {
  return (
    <svg className={styles.heart} viewBox="0 0 48 46" role="progressbar" aria-busy="true" aria-label="Loading">
      <path className={styles.track} d={HEART} pathLength="100"/>
      <path className={styles.trace} d={HEART} pathLength="100"/>
    </svg>
  );
}
